( function( $ ) {
	var button = $( 'button.js-toggle-content' );
	button.on( 'click', function() {
		$( this )
			.siblings( '.js-toggled-content' )
			.toggleClass( 'h-toggled-content' );
		$( this ).toggleClass( 'h-toggled-button' );
	} );
} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/toggle-content.js